import React, { useEffect, useMemo, useState } from 'react';
import { Input } from 'reactstrap';
import PageClean from '../default/PageClean';
import Alert from '../../components/Alert';
import Select from 'react-select';
import MaskedInput from 'react-text-mask';
import AltCheckbox from '../../components/AltCheckbox';
import { validateCNPJ, validateCPF } from '../../config/Validator';
import { getPostalCodeAddress } from './CustomerForm';

const aMaskCpf = [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/];
const aMaskCnpj = [/\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/];
const aMaskCep = [/\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/];
const aMaskPhone = ['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, /\d/];

const CustomerFinancial = ({
  oCustomer,
  onClose = () => {},
  onSubmit = () => {},
}) => {
  const [bIsSubmitting, setIsSubmitting] = useState(false);
  const [aErrors, setErrors] = useState([]);

	const [oCustEdit, setCustEdit] = useState({});

  useEffect(() => {
    if (!oCustomer) return;
    setCustEdit({ ...oCustomer });
  }, [oCustomer]);

  const bIsCustWL = useMemo(() => {
    if (!oCustomer) return false;
    return !!oCustomer.wlpn_nid;
  }, [oCustomer]);

  const handleSubmit = async (evtSubmit) => {
    evtSubmit.preventDefault();
    if (bIsSubmitting) return;

    setIsSubmitting(true);
    try {
      await onSubmit(oCustEdit, true);
    } catch (oError) {
      setErrors((aPrevErrors) => [...aPrevErrors, ...oError.aMsgErrors]);
      setIsSubmitting(false);
    }
  };

  const handleClose = (evtClick) => {
    onClose();
  };

  const handleCustomerChange = (evtChange) => {
    const cName = evtChange.target.name;
    const cValue = evtChange.target.value;
    setCustEdit((oPrevCust) => ({ ...oPrevCust, [cName]: cValue }));
  };

  const handleBlurCnpj = (evtBlur) => {
    const cValue = evtBlur.target.value;
    if (!cValue) return;
    const bIsValid = validateCNPJ(cValue);
    if (!bIsValid) {
      setErrors((aPrevErrors) => {
        const cInvalidCnpjMsg = 'CNPJ inválido';
        if (aPrevErrors.includes(cInvalidCnpjMsg)) return aPrevErrors;
        return [...aPrevErrors, cInvalidCnpjMsg];
      });
    }
  };

  const handleBlurCpf = (evtBlur) => {
    const cValue = evtBlur.target.value;
    if (!cValue) return;
    const bIsValid = validateCPF(cValue);
    if (!bIsValid) {
      setErrors((aPrevErrors) => {
        const cInvalidCpfMsg = 'CPF inválido';
        if (aPrevErrors.includes(cInvalidCpfMsg)) return aPrevErrors;
        return [...aPrevErrors, cInvalidCpfMsg];
      });
    }
  };

  const handleChangePostalcode = async (evtChange) => {
    const cPostalCode = evtChange.target.value;
    handleCustomerChange(evtChange);

    if (!/[0-9]$/.test(cPostalCode)) return;
    try {
      const oResult = await getPostalCodeAddress(cPostalCode);
      setCustEdit((oPrevCust) => ({
        ...oPrevCust,
        ...oResult
      }));
    } catch (oError) {
      console.log(oError);
    }
  };

  const clearError = (cError) => {
    setErrors((aPrv) => aPrv.filter((cErr) => cErr !== cError));
  };

  return (
    <PageClean bLoading={false}>
      {aErrors.map((cError) => (
        <Alert key={cError} type="error" onCloseAlert={() => clearError(cError)}>{cError}</Alert>
      ))}
      <form autoComplete="false" onSubmit={handleSubmit} className="form" style={{ paddingRight: '10px' }}>
        <fieldset>
          <legend>Informações Cadastrais</legend>

          <Select
            className="selectCustom"
            classNamePrefix="react-select"
            noOptionsMessage={() => ''}
            placeholder="Selecione"
            options={[ {label: 'PF', value: 'PF'}, {label: 'PJ', value: 'PJ'} ]}
            maxMenuHeight={190}
            defaultValue={{ label: oCustomer.cust_ctype, value: oCustomer.cust_ctype }}
            onChange={(oOption) => setCustEdit(oPrv => ({ ...oPrv, cust_ctype: oOption.value }))}
          />

          {oCustEdit.cust_ctype === 'PF' ? (<>
            <label className="split3 colspan">
              <span>
                Nome completo <span className="required">*</span>
              </span>
              <Input
                type="text"
                name="cust_cname"
                required
                value={oCustEdit.cust_cname || ''}
                onChange={handleCustomerChange}
                readOnly={bIsCustWL}
              />
            </label>

            <label className="split3">
              <span>
                CPF <span className="required">*</span>
              </span>
              <MaskedInput
                onBlur={handleBlurCpf}
                mask={aMaskCpf}
                onChange={handleCustomerChange}
                render={(cRef, oProps) => (
                  <Input
                    innerRef={cRef}
                    {...oProps}
                    value={oCustEdit.cust_ccpf || ''}
                    type="text"
                    name="cust_ccpf"
                    id="cust_ccpf"
                    className="mask-cpf"
                    placeholder="CPF"
                    required
                    readOnly={bIsCustWL}
                  />
                )}
              />
            </label>
          </>) : (<>
            <label>
              <span>
                Razão social <span className="required">*</span>
              </span>
              <Input
                type="text"
                name="cust_cname"
                required
                value={oCustEdit.cust_cname || ''}
                onChange={handleCustomerChange}
                readOnly={bIsCustWL}
              />
            </label>

            <label className="split2">
              <span>
                Nome fantasia <span className="required">*</span>
              </span>
              <Input
                type="text"
                name="cust_cname"
                required
                value={oCustEdit.cust_cfantasyname || ''}
                onChange={handleCustomerChange}
                readOnly={bIsCustWL}
              />
            </label>

            <label className="split2">
              <span>
                CNPJ <span className="required">*</span>
              </span>
              <MaskedInput
                onBlur={handleBlurCnpj}
                mask={aMaskCnpj}
                onChange={handleCustomerChange}
                render={(cRef, oProps) => (
                  <Input
                    innerRef={cRef}
                    {...oProps}
                    value={oCustEdit.cust_ccnpj || ''}
                    type="text"
                    name="cust_ccnpj"
                    id="cust_ccnpj"
                    placeholder="CNPJ"
                    required
                    readOnly={bIsCustWL}
                  />
                )}
              />
            </label>

            <label className="split2">
              <span>
                Inscrição estadual <span className="required">*</span>
              </span>
              <Input
                type="text"
                name="cust_cIE"
                minLength={5}
                required
                value={oCustEdit.cust_cIE || ''}
                onChange={handleCustomerChange}
                readOnly={bIsCustWL}
              />
            </label>

            <label className="split2">
              <span>
                Inscrição municipal
              </span>
              <Input
                type="text"
                name="cust_cIE"
                value={oCustEdit.cust_cIM || ''}
                onChange={handleCustomerChange}
                readOnly={bIsCustWL}
              />
            </label>

            <AltCheckbox
              checked={oCustEdit.ca_bispublic}
              onChange={(evtChange) => {
                const bChecked = evtChange.target.checked;
                setCustEdit((oPrv) => ({
                  ...oPrv,
                  ca_bispublic: bChecked,
                  ca_bissimple: (bChecked ? false : oPrv.ca_bissimple)
                }));
              }}
              name="ca_bispublic"
              label="Entidade pública"
              disabled={bIsCustWL}
            />

            <AltCheckbox
              checked={oCustEdit.bUseSimple}
              onChange={(evtChange) => handleCustomerChange({
                target: { name: 'ca_bissimple', value: evtChange.target.checked }
              })}
              disabled={bIsCustWL || oCustEdit.ca_bispublic}
              name="ca_bissimple"
              label="Optante pelo Simples"
            />
          </>)}
        </fieldset>

        <fieldset>
          <legend>Endereço</legend>

          <label className="split3">
            <span>
              CEP <span className="required">*</span>
            </span>
            <MaskedInput
              mask={aMaskCep}
              onChange={handleChangePostalcode}
              render={(cRef, oProps) => (
                <Input
                  innerRef={cRef}
                  {...oProps}
                  value={oCustEdit.cust_cpostalcode || ''}
                  type="text"
                  className="mask-cep cep-fill"
                  name="cust_cpostalcode"
                  id="cust_cpostalcode"
                  placeholder="CEP"
                  readOnly={bIsCustWL}
                />
              )}
            />
          </label>

          <label className="split3">
            <span>
              Cidade <span className="required">*</span>
            </span>
            <Input
              type="text"
              name="cust_ccity"
              value={oCustEdit.cust_ccity || ''}
              required
              readOnly
            />
          </label>

          <label className="split3">
            <span>
              Estado <span className="required">*</span>
            </span>
            <Input
              type="text"
              name="cust_cstate"
              value={oCustEdit.cust_cstate || ''}
              required
              readOnly
            />
          </label>

          <label className="split3 colspan">
            <span>
              Endereço <span className="required">*</span>
            </span>
            <Input
              type="text"
              name="cust_cstreet"
              value={oCustEdit.cust_cstreet || ''}
              required
              readOnly
            />
          </label>

          <label className="split3">
            <span>
              Bairro <span className="required">*</span>
            </span>
            <Input
              type="text"
              name="cust_cdistrict"
              value={oCustEdit.cust_cdistrict || ''}
              required
              readOnly
            />
          </label>

          <label className="split3">
            <span>
              Número <span className="required">*</span>
            </span>
            <Input
              type="text"
              name="cust_cnumber"
              value={oCustEdit.cust_cnumber || ''}
              onChange={handleCustomerChange}
              required
              readOnly={bIsCustWL}
            />
          </label>

          <label className="split3 colspan">
            <span>
              Complemento
            </span>
            <Input
              type="text"
              name="cust_ccomplement"
              value={oCustEdit.cust_ccomplement || ''}
              onChange={handleCustomerChange}
              readOnly={bIsCustWL}
            />
          </label>

        </fieldset>

        <fieldset>
          <legend>Contato</legend>
          <label className="split3 colspan">
            <span>
              E-mail <span className="required">*</span>
            </span>
            <Input
              type="email"
              name="ca_cemail"
              value={oCustEdit.ca_cemail || ''}
              onChange={handleCustomerChange}
              required
              readOnly={bIsCustWL}
            />
          </label>

          <label className="split3">
            <span>
              Telefone <span className="required">*</span>
            </span>
            <MaskedInput
                mask={aMaskPhone}
                onChange={handleCustomerChange}
                render={(cRef, oProps) => (
                  <Input
                    innerRef={cRef}
                    {...oProps}
                    value={oCustEdit.cust_cphone || ''}
                    type="text"
                    name="cust_cphone"
                    id="cust_cphone"
                    className="mask-phone"
                    placeholder="Telefone"
                    required
                    readOnly={bIsCustWL}
                  />
                )}
              />
          </label>
        </fieldset>

        <div className="button-stack">
          <button
            type="button"
            className="btn alternate back btn btn-outline-secondary" title="Voltar"
            onClick={handleClose}
          >
            Voltar
          </button>
          <button type="submit" className="btn btn btn-secondary" title={oCustomer.bIsTrial ? "Contratar" : "Alterar"}>
            {oCustomer.bIsTrial ? "Contratar" : "Alterar"}
          </button>
        </div>
      </form>
    </PageClean>
  );
};

export default CustomerFinancial;